export default "__VITE_ASSET__835e85a7__"